import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { DEFAULT_CONTENT } from "@/lib/contentDefaults";

const get = (url) => async () => (await api.get(url)).data;

export const useContent = () => {
  const q = useQuery({ queryKey: ["content"], queryFn: get("/content") });
  const content = { ...DEFAULT_CONTENT, ...(q.data || {}) };
  return { ...q, content };
};

export const useProducts = (params = "") => useQuery({ queryKey: ["products", params], queryFn: get(`/products${params}`) });
export const useProduct = (id) => useQuery({ queryKey: ["product", id], queryFn: get(`/products/${id}`), enabled: !!id });
export const useCollections = () => useQuery({ queryKey: ["collections"], queryFn: get("/collections") });
export const useTestimonials = (params = "") => useQuery({ queryKey: ["testimonials", params], queryFn: get(`/testimonials${params}`) });
export const useProjects = (params = "") => useQuery({ queryKey: ["projects", params], queryFn: get(`/projects${params}`) });
export const useProject = (id) => useQuery({ queryKey: ["project", id], queryFn: get(`/projects/${id}`), enabled: !!id });
export const useNews = () => useQuery({ queryKey: ["news"], queryFn: get("/news") });
export const useStats = () => useQuery({ queryKey: ["stats"], queryFn: get("/stats") });
